<template>
  <div style="height: 100%;width: 100%;">
    <apexchart
      height="100%"
      :options="OPCOES"
      :series="SERIES"
    />
  </div>
</template>

<script>
import formatarValoresBi from "@/helpers/formatarValoresBi";
import {cores, nomes} from "@/components/Diagnostico/CurvasCruzadas/IndicadorEvolucao/InformacoesGrafico";
import {serie_padrao} from "@/components/Diagnostico/CurvasCruzadas/IndicadorEvolucao/SeriePadrao";
import {formatarValorComCasas} from "@/helpers";

export default {
  name: "Chart",
  props: ['dados'],
  computed: {
    VALOR_MAXIMO_EIXO_Y() {
      let valor = this.maxValorNaSerie('total_estoque')
      valor += this.maxValorNaSerie('total_aumentar');
      return valor || 1
    },
    VALOR_MINIMO_EIXO_Y() {
      return this.minValorNaSerie('total_reduzir');
    },
    PONTOS_ANOTACAO() {
      return this.getPontosChart();
    },
    OPCOES() {
      const vm = this;

      return {
        chart: {
          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
          redrawOnParentResize: true,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: false
          },
          type: "bar",
          events: {
            dataPointSelection: function(event, chartContext, config) {
              vm.$emit("click:range-grafico", {event, chartContext, config});
            }
          }
        },
        grid: {
          show: true,
          borderColor: '#e5e5e5',
          position: "back",
          yaxis: {
            lines: {
              show: true
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -4,
          textAnchor: 'middle',
          style: {
            fontSize: "11px",
            fontWeight: 400,
            colors: ["#FFF", "#5db90a", "#2f2f2f", "#FFF"],
          },
          background: {
            enabled: false
          },
          formatter: function (val) {
            return formatarValoresBi(val || 0, 5, 6);
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 2,
            horizontal: false,
            dataLabels: {
              position: 'center'
            }
          }
        },
        stroke: {
          width: [0, 1, 1, 0, 0],
          curve: 'straight',
        },
        tooltip: {
          enabled: false
        },
        xaxis: {
          labels: {
            offsetY: 3,
            style: {
              fontSize: '13px',
              fontWeight: 600
            },
            formatter: function (val) {
              return val || '-';
            }
          }
        },
        markers: {
          size: 3.5,
          strokeWidth: 2,
          hover: {
            size: 8
          }
        },
        legend: {
          show: false,
        },
        labels: this.getSerie('referencias'),
        yaxis: {
          max: this.VALOR_MAXIMO_EIXO_Y,
          min: this.VALOR_MINIMO_EIXO_Y,
          labels: {
            formatter: (n) => {
              if (!this.dados.total_estoque) return '-';

              if (Math.abs(n) < 1000) {
                return formatarValorComCasas(n, 1);
              }

              return formatarValoresBi(n || 1, 5, 6);
            }
          }
        },
        annotations: {
          position: 'front',
          points: this.PONTOS_ANOTACAO
        }
      };
    },
    SERIES() {
      return [
        {
          name: nomes.total_reduzir,
          data: this.getSerie('total_reduzir'),
          type: 'column',
          color: cores.total_reduzir
        },
        {
          name: nomes.estoque_parametrizavel,
          data: this.getSerie('estoque_parametrizavel'),
          type: 'line',
          color: cores.estoque_parametrizavel
        },
        {
          name: nomes.total_estoque,
          data: this.getSerie('total_estoque'),
          type: 'column',
          color: cores.total_estoque
        },
        {
          name: nomes.total_aumentar,
          data: this.getSerie('total_aumentar'),
          type: 'column',
          color: cores.total_aumentar
        },
      ];
    }
  },
  methods: {
    getSerie(nome){
      if (this.dados && this.dados[nome] && this.dados[nome].length > 0) {
        return this.dados[nome];
      }
      return serie_padrao;
    },
    maxValorNaSerie(nome_serie) {
      const callback = (a, b) => Math.max(a, b);
      return parseInt(this.getSerie(nome_serie).reduce(callback, 0));
    },
    minValorNaSerie(nome_serie) {
      const callback = (a, b) => Math.min(a, b);
      return parseInt(this.getSerie(nome_serie).reduce(callback, 0));
    },
    getPontosChart() {
      const callback = (y, index) => {
        const x = this.getSerie('referencias')[index];
        return this.getModeloPontoChart(y, x, cores.diferenca);
      };

      return this.getSerie('diferenca').map(callback);
    },
    getModeloPontoChart(y, x, cor) {
      const ponto = {
        x: null,
        y: null,
        marker: {
          size: 0,
          fillColor: null,
          strokeWidth: 0,
          shape: "circle",
          radius: 2,
          OffsetX: 0,
          OffsetY: 0,
          cssClass: '',
        },
        label: {
          borderWidth: 0,
          text: null,
          offsetY: 5,
          style: {
            background: 'transparent',
            color: null,
            fontSize: '11px',
          },
        },
      };

      if (y <= 0 || !y) {
        return ponto;
      }

      ponto.x = x;
      ponto.y = y;
      ponto.marker.fillColor = cor;
      ponto.label.text = formatarValoresBi(y, 5, 6);
      ponto.label.style.color = cor;

      return ponto;
    }
  }
}
</script>

<style scoped>

</style>
